<template>
    <v-card > 
 <v-list>


      <v-list-group
        prepend-icon="mdi-bed"
        value="true"
        v-for="(room,key,index) in rooms" :key="index"
      >

          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{labels.room}} {{index + 1}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="mainguest.roomid == key"
            @click="$store.commit('editMainGuest',mainguest); $vuetify.goTo('#curr_element', {})"
            link>
            <v-list-item-title >{{mainguest.firstName}} {{mainguest.lastName}}</v-list-item-title>
            <v-list-item-icon>
                  <v-badge left  color="orange"  overlap>
                      <v-icon color="white" slot="badge">mdi-star</v-icon>                   
                      <v-icon large :color="mainguest.iscompiled ? 'success':'grey'" >mdi-account-circle</v-icon>                  
                  </v-badge>   
            </v-list-item-icon>
          </v-list-item>

          <v-list-item
           v-for="(member,indice) in members(key)" :key="indice" 
            @click="$store.commit('editGuest',member); $vuetify.goTo('#curr_element', {})"  
            link
          >
            <v-list-item-title >{{member.firstName || 'Guest '+ (indice+1)}} {{member.lastName}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon :color="member.iscompiled ? 'success':'grey'">mdi-account-circle</v-icon>
            </v-list-item-icon>
          </v-list-item>
          </v-list-group>

    </v-list>



                 <v-card class="text-xs-center">
                    <v-flex>
                      <!-- @click= "dialog=true"   questo è il click per chiedere conferma ulteriore--> 
                      <v-btn                     
                      :loading="loading3"
                      
                      @click.native="loader = 'loading3'"
                      @click="closeReservation" 
                      :disabled="!invioAbilitato || PrenotazioneChiusa"
                      color="green"
                      class="white--text"
                      block
                      >
                        {{labels.save_and_send}}
                        <v-icon right dark>mdi-upload</v-icon>
                      </v-btn>
                      <v-dialog v-model="dialog" max-width="290">
                          <v-card>
                            
                                <v-card-text>{{labels.confirm_question}}</v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" flat="flat" @click.native="dialog = false">Annulla</v-btn>
                              <v-btn color="primary" flat="flat" @click="closeReservation">Invia</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                  </v-flex>
          </v-card>    
          

    </v-card>
</template>


<script>
/*
var groupBy_old = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};*/
function groupBy(xs, key) {
  
  console.log("GROUPBY",xs, key);
  if(Array.isArray(xs)){
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
  else{
    var r =[];
    r[key] = xs;
    return r;
  }

}

export default {
  props: ["dati", "dativisitor", "mainguest","rooms","labels"],
  data() {
    return {
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false,
      dialog: false,
      iscompiled:false,
      ismodified:false,
      e3: 1,
      e31: true,
      pannelli:[[true],[true]],
      loaded:false
    }
  },
  watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      }
  },
  computed:{
    PrenotazioneChiusa(){
        return this.$store.state.reservation.status === 'CLOSED';
      },
    invioAbilitato(){
      var ret = false;
      console.log("PRONC OSP is compiled:",this.mainguest.iscompiled)
      console.log("PRINC OSP is compiled 2:",this.$store.state.reservation.config.GuestsDataOptional)
      console.log("PRINC OSP is compiled 3:",this.OspitiCompletati())
      console.log("PRINC OSP is compiled 5:",!this.$store.state.reservation.config.GuestsDataOptional)

      if(!(typeof this.$store.state.reservation.config.GuestsDataOptional === 'undefined' || this.$store.state.reservation.config.GuestsDataOptional === null)){
        
          if(this.mainguest.iscompiled && (this.$store.state.reservation.config.GuestsDataOptional==1 )){
            ret = true;
            console.log("PRINC OSP --> 1",ret);
          }

          if(this.mainguest.iscompiled && (this.$store.state.reservation.config.GuestsDataOptional==0) && this.OspitiCompletati()){
            ret = true;
            console.log("PRINC OSP --> 2",ret);
          }
      }else{
          ret = this.mainguest.iscompiled;
          console.log("PRINC OSP --> 3",ret);
      }

      console.log("PRINC OSP is compiled 4:",ret)
       return ret;
    }
  },
  methods: {
    stanze () {
      var a = groupBy(this.dati,'roomid');
      console.log('stanze2',a)
        return (a)
      },
    members(roomid){
      console.log("membri",this.dati,roomid)
      let v=this.dati.filter(x=>x.roomid == roomid);  
      console.log("membri2",v)
      return v
    },  
    addGuest(roomid) {
      // this.$emit('addguest')
      console.log("AGGIUNTA OSPITE IN CORSO",roomid)
      this.$store.commit("increment");
      this.$store.commit("addGuest",roomid);
    },
    closeReservation() {
      // this.$emit('addguest')
      this.$store.dispatch("closeReservation")
      .then( x => {
        console.log(x)
        /* if(this.$store.config.firmacontratto){
          this.$router.push({ path: `/firma` })
        }
        */
        this.$router.push({ path: `/bye` })
      })
       //window.location.href = "#/bye";
       

    },
    OspitiCompletati(){
      var ret = true;
      this.$store.state.reservation.visitors.forEach(function (element) {
        ret = ret && element.iscompiled;
      })
      console.log("tutti completati:",true,this.mainguest)
      return ret;
    },
    getImage(member) {
      if (member.gender.Codice === "F") {
        return "static/img/faces/face-6.jpg";
      }
      if (member.gender.Codice === "M") {
        return "static/img/faces/face-1.jpg";
      }
      return "static/img/faces/face-0.jpg";
    },
    getStatusClass(status) {
      switch (status) {
        case "Dati non inseriti":
          return "text-muted";
        case "Dati inseriti":
          return "text-success";
        case "Dati mancanti":
          return "text-danger";
        default:
          return "text-success";
      }
    }
  },
  

  mounted() {
    console.log("STANZAE",this.rooms);

    if(this.rooms.length == 0)
    {
      var a = groupBy(this.dati,'roomid');
      this.rooms = a;
      this.rooms[this.mainguest.roomid]='camera capo';
      
    }

      
  }
};
</script>



